import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        course: '=',
        context: '=',
        fields: '=',
        sites: '=',
        certificates: '='
    },
    template: `
        <form role="form" class="form" ng-submit="vm.save()">
            <h2>{{ 'courses.General data' | translate }}</h2>
            <div class="form">
                <form-wrapper form="vm.form">
                    <form-row error="vm.form.errors.courseI18ns[vm.defaultLanguage].name">
                        <label class="label">{{ 'course.Course name' | translate }} *</label>
                        <div class="items">
                            <input ng-disabled="!vm.canManageCourse || vm.form.model.isArchived" ng-model="vm.form.model.courseI18ns[vm.defaultLanguage].name" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row
                        ng-if="vm.TokenService.isGuidanceModuleEnabled() && vm.TokenService.hasPrivilege('GUIDANCE_MODIFY')"
                        error="vm.form.errors.isGuidance">
                        <span class="label">{{ 'course.Is guidance' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input
                                    ng-disabled="!vm.canManageCourse || vm.form.model.isArchived"
                                    type="checkbox"
                                    ng-model="vm.form.model.isGuidance"
                                >
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.requiresStrongAuthentication">
                        <span class="label">
                            {{ 'course.Requires strong authentication' | translate }}
                            <tooltip html="vm.tooltipTexts.requiresStrongAuthentication" />
                        </span>
                        <div class="items">
                            <label class="switch01">
                                <input
                                    ng-disabled="!vm.canManageCourse || vm.form.model.isArchived"
                                    type="checkbox"
                                    ng-model="vm.form.model.requiresStrongAuthentication"
                                >
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.sop" ng-if="vm.TokenService.isCompanyMagnum()">
                        <label class="label">{{ 'course.SOP nr' | translate }}</label>
                        <div class="items">
                            <input ng-disabled="!vm.canManageCourse || vm.form.model.isArchived" ng-model="vm.form.model.sop" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.courseI18ns[vm.defaultLanguage].description">
                        <label class="label">
                            {{ 'course.Description' | translate }}
                            <tooltip html="vm.tooltipTexts.description" />
                        </label>
                        <div class="items" style="{{ vm.form.model.isArchived ?'pointer-events: none' : '' }}">
                            <ng-ckeditor
                                ng-model="vm.form.model.courseI18ns[vm.defaultLanguage].description"
                                class="mt10"
                                ng-config="vm.ckconfig">
                            </ng-ckeditor>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.fields">
                        <label class="label">{{ 'course.Fields' | translate }}</label>
                        <div class="items">
                            <div
                                ng-dropdown-multiselect=""
                                options="vm.multiFilter.fields.options"
                                selected-model="vm.multiFilter.fields.models"
                                extra-settings="vm.multiFilter.fields.settings"
                                translation-texts="vm.multiFilter.fields.translations"
                                disabled="!vm.canManageCourse || vm.form.model.isArchived"
                                >
                            </div>
                            <form-row-error></form-row-error>
                            <a class="btn discrete small" ng-click="vm.addField()" ng-if="!vm.form.model.addField || !vm.form.model.isArchived">
                                {{ 'course.Add new training field' | translate }}
                            </a>
                            <a class="btn discrete small" ng-click="vm.cancelAddField()" ng-if="vm.form.model.addField && !vm.form.model.isArchived">
                                {{ 'general.Remove' | translate }}
                            </a>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.fieldName" ng-if="vm.form.model.addField">
                        <label class="label"></label>
                        <div class="items">
                            <input ng-disabled="!vm.canManageCourse || vm.form.model.isArchived"
                                placeholder="{{ 'course.Field name' | translate }}" ng-model="vm.form.model.fieldName" type="text" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>

                    <form-row error="vm.form.errors.expirationMonths">
                        <label class="label">
                            {{ 'course.Course repeatability' | translate }} *
                            <tooltip html="vm.tooltipTexts.expiration" />
                        </label>
                        <div class="items">
                            <ul ng-if="vm.canManageCourse" class="checkboxes03">
                                <li ng-repeat="expiration in vm.expirationOptions">
                                    <label><input ng-disabled="vm.form.model.isArchived" type="radio" ng-model="vm.expiration" ng-value="{{ expiration.value }}">
                                        <span>{{ expiration.label }}</span>
                                    </label>
                                </li>
                            </ul>
                            <span ng-if="!vm.canManageCourse" class="text">{{ vm.selectedExpiration.label }}</span>
                            <form-row-error ng-if="vm.expiration!==vm.COURSE_EXPIRATION_ENUM.KEYS.OTHER"></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.expirationMonths" ng-if="vm.expiration==vm.COURSE_EXPIRATION_ENUM.KEYS.OTHER">
                        <span class="label"></span>
                        <div class="items">
                            <input type="number"
                                    ng-disabled="!vm.canManageCourse || vm.form.model.isArchived"
                                    ng-model="vm.customExpiration.years"
                                    ng-change="vm.handleExpirationValues()"
                                    class="form-control min"
                                    min="0"
                                    maxlength="2"
                                    max="99"
                            >
                                <label>{{ vm.getExpirationYearsLabel() }}</label>
                            <input type="number"
                                    ng-disabled="!vm.canManageCourse || vm.form.model.isArchived"
                                    ng-model="vm.customExpiration.months"
                                    ng-change="vm.handleExpirationValues()"
                                    class="form-control min"
                                    min="0"
                                    maxlength="2"
                                    max="12"
                            >
                                <label> {{ vm.getExpirationMonthsLabel() }}</label>
                            <form-row-error ng-if="vm.expiration===vm.COURSE_EXPIRATION_ENUM.KEYS.OTHER"></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.isCertifiedCourse">
                        <span class="label">{{ 'course.Issues a certificate' | translate }}</span>
                        <div class="items">
                            <label class="switch01">
                                <input
                                    ng-disabled="!vm.canManageCourse || vm.form.model.isArchived"
                                    type="checkbox"
                                    ng-model="vm.form.model.isCertifiedCourse"
                                    ng-click="vm.toggleCertType()"
                                >
                                <span>{{ 'general.Yes' | translate }}</span>
                            </label>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.certificateNumberingType" ng-if="vm.form.model.isCertifiedCourse">
                        <span class="label">{{ 'course.Certificate numbering' | translate }}</span>
                        <div class="items">
                            <ul class="checkboxes">
                                <li>
                                    <label>
                                        <input
                                            ng-disabled="vm.form.model.userCertificates.length || vm.form.model.isArchived"
                                            ng-model="vm.form.model.certificateNumberingType"
                                            value="{{ vm.COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM.KEYS.COMPANY_BASED }}"
                                            ng-value="vm.COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM.KEYS.COMPANY_BASED"
                                            type="radio"> {{ vm.COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM.LABELS.COMPANY_BASED }}
                                    </label>
                                </li>
                                <li>
                                    <label>
                                        <input
                                            ng-disabled="vm.form.model.userCertificates.length || vm.form.model.isArchived"
                                            ng-model="vm.form.model.certificateNumberingType"
                                            value="{{ vm.COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM.KEYS.COURSE_BASED }}"
                                            ng-value="vm.COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM.KEYS.COURSE_BASED"
                                            type="radio"> {{ vm.COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM.LABELS.COURSE_BASED }}
                                    </label>
                                </li>
                            </ul>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row
                      error="vm.form.errors.companyCertificateId"
                      ng-if="vm.form.model.isCertifiedCourse && vm.certificates.length">
                      <label class="label">{{ 'course.Certificate template' | translate }} *</label>
                      <div class="items">
                        <select class="form-control"
                                ng-model="vm.form.model.companyCertificateId"
                                ng-change="vm.changeCertificateTemplate()"
                                ng-disabled="!vm.canManageCourse"
                                ng-options="certificate.id as certificate.activeI18n.templateName
                                            for certificate in vm.certificates">
                        </select>
                        <form-row-error></form-row-error>
                      </div>
                    </form-row>
                    <form-row error="vm.form.errors.file">
                        <label class="label">{{ 'course.Course image' | translate }}</label>
                        <div class="items">
                            <input ng-if="vm.course" ng-disabled="!vm.canManageCourse || vm.form.model.isArchived" ngf-select="vm.setFile($file)" ng-model="vm.form.model.file" type="file" />
                            <span ng-if="vm.course && vm.course.imageFilename" class="text">
                                <img ng-src="{{vm.CourseService.getImageUrl(vm.course, 'small')}}" /><br>
                                <a ng-click="vm.deleteImage()" class="ml10 btn delete">{{ 'general.Remove' | translate }}</a>
                            </span>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.courseI18ns[vm.defaultLanguage].planningRecommendation">
                        <label class="label">{{ 'course.Planning recommendation' | translate }}</label>
                        <div class="items">
                            <textarea ng-disabled="!vm.canManageCourse || vm.form.model.isArchived"
                                ng-model="vm.form.model.courseI18ns[vm.defaultLanguage].planningRecommendation" class="form-control"></textarea>
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>

                    <form-row error="vm.form.errors.courseSiteIds">
                        <label class="label">{{ 'course.Access' | translate }} *<br>
                            <small>{{ 'course.Define the Sites that can access the course' | translate }}</small>
                        </label>
                        <div class="items">
                            <div ng-dropdown-multiselect=""
                                options="vm.multiFilter.sites.options"
                                selected-model="vm.multiFilter.sites.models"
                                extra-settings="vm.multiFilter.sites.settings"
                                events="vm.multiFilter.sites.events"
                                disabled="!vm.canManageSiteAccess || vm.form.model.isArchived"
                                translation-texts="vm.multiFilter.sites.translations"
                            ></div>
                        </div>
                    </form-row>
                    <form-row error="vm.form.errors.courseSiteIds" ng-if="vm.form.errors.courseSiteIds">
                        <label class="label"></label>
                        <div class="items"><form-row-error></form-row-error></div>
                    </form-row>
                    <form-row error="vm.form.errors.courseOwner">
                        <label class="label">{{ 'course.Course owner' | translate }}</label>
                        <div class="items">
                            <autocomplete
                                label-attribute="'displayName'"
                                selected-item="vm.selectedOwner"
                                ng-model="vm.form.model.ownerId"
                                value-attribute="'id'"
                                placeholder="vm.$translate.instant('filter.Find an employee')"
                                query="vm.queryUsers(input)"
                            />
                        </div>
                    </form-row>
                </form-wrapper>
            </div>
            <button type="submit" class="hidden" >{{ 'general.Save changes' | translate }}</button>
        </form>
    <ul class="actions01">
        <li class="primary">
            <a ng-if="vm.canManageCourse && !vm.form.model.isArchived"
                ng-click="vm.save()" class="{{ 'btn main' }} {{ vm.form.model.isArchived ? 'disabled' : '' }}"
                ng-disabled="vm.loader" ng-class="{'loading': vm.loader}"
            >
                <span ng-if="vm.context==='edit'">{{ 'general.Save' | translate }}</span>
                <span ng-if="vm.context==='add'">{{ 'general.Next' | translate }}</span>
            </a>
        </li>
        <li class="primary">
            <a
                ng-if="vm.context==='edit' && vm.canManageCourse && !vm.form.model.isArchived"
                ng-click="vm.clone(vm.form.model.courseI18ns[vm.defaultLanguage])" class="btn bordered02">
                <span>{{ 'general.Clone' | translate }}</span>
            </a>
        </li>
        <li class="primary">
            <a ng-if="vm.context==='edit' && vm.canManageCourse && !vm.form.model.isArchived" ng-click="vm.archive(true)" class="btn negative">
                <span>{{ 'general.Archive' | translate }}</span>
            </a>
            <a ng-if="vm.canManageCourse && vm.form.model.isArchived" ng-click="vm.archive(false)" class="btn positive">
                <span ng-if="vm.context==='edit'">{{ 'general.Reactivate' | translate }}</span>
            </a>
        </li>
        <li>
            <a ui-sref="authorized.courses.courses.list()" class="btn discrete" >
                <span ng-if="vm.context==='edit'">{{ 'general.Back to list' | translate }}</span>
                <span ng-if="vm.context==='add'">{{ 'general.Cancel' | translate }}</span>
            </a>
        </li>
    </ul>
    `
})

export default class {
    constructor ($state, $translate, lodash, FormFactory, ResponseService, CourseService, PrivilegeService, NumberService,
                 CkEditorService, TokenService, ModalService, CourseResource, Upload, COURSE_EXPIRATION_ENUM,
                 COURSE_SITE_ACCESS_ENUM, COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM, SiteService, $rootScope,
                 toastr, UserResource, ROLE_COMPANY_MODULE_PRIVILEGE_ENUM) {
        this.$translate = $translate;
        this.FormFactory = FormFactory;
        this.ResponseService = ResponseService;
        this.$state = $state;
        this.CourseService = CourseService;
        this.PrivilegeService = PrivilegeService;
        this.TokenService = TokenService;
        this.ModalService = ModalService;
        this.NumberService = NumberService;
        this.CourseResource = CourseResource;
        this.UserResource = UserResource;
        this.CkEditorService = CkEditorService;
        this.COURSE_EXPIRATION_ENUM = COURSE_EXPIRATION_ENUM;
        this.COURSE_SITE_ACCESS_ENUM = COURSE_SITE_ACCESS_ENUM;
        this.COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM = COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM;
        this.ROLE_COMPANY_MODULE_PRIVILEGE_ENUM = ROLE_COMPANY_MODULE_PRIVILEGE_ENUM;
        this.lodash = lodash;
        this.Upload = Upload;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.SiteService = SiteService;
        this.$rootScope = $rootScope;
        this.toastr = toastr;
        this.loader = false;
    }

    $onInit () {
        this.customExpiration = {
            years: null,
            months: null
        };
        this.expiration = this.course.expirationMonths ? this.course.expirationMonths : 12;
        this.chosenFields = [];
        this.expirationOptions = this.CourseService.getExpirationOptions();

        if (!this.course.id) {
            this.course.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            if (this.showAllSites()) {
                this.course.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
        }

        this.form = this.FormFactory.createFromResource(this.course);

        if (this.course.id) {
            this.initCourse();
        }

        if (!this.selectedOwner) {
            this.initOwner();
        }

        this.selectedExpiration = this.lodash.find(
            this.expirationOptions,
            { value: this.NumberService.isInteger(this.expiration) ? this.expiration : `'${this.expiration}'` }
        );

        this.initMultiFilter();
        this.canManageCourse = this.CourseService.canManageCourse(this.course);
        this.canManageSiteAccess = this.PrivilegeService.isCompanyAdmin()
            || !this.course.id
            || (this.canManageCourse && this.course.sites && this.course.sites.length === 1);

        this.ckconfig = this.CkEditorService.getDefaultConfig();
        this.ckconfig.readOnly = !this.canManageCourse;
        this.certTypeOnLoad = this.form.model.certificateNumberingType;
        this.form.model.companyCertificateId = this.form.model.companyCertificateId ? parseInt(this.form.model.companyCertificateId, 10) : null;
        this.oldCompanyCertificateId = this.form.model.companyCertificateId;

        this.tooltipTexts = {
            expiration: this.$translate.instant('course.repeatability tooltip'),
            description: this.$translate.instant('course.Description tooltip'),
            requiresStrongAuthentication: this.$translate.instant('course.Requires strong authentication tooltip')
        };
    }

    queryUsers (name, ids = []) {
        let siteIds = this.sites.map(site => site.id);
        if (!siteIds.length) {
            siteIds = [-1];
        }
        const params = {
            ids,
            name,
            pageSize: 0,
            siteIds,
            privilegesCheck: false
        };

        return this.UserResource.getUsers({}, params).$promise;
    }

    initOwner () {
        if (this.context === 'add') {
            const currentUser = this.TokenService.getUser();
            this.selectedOwner = currentUser;
            this.selectedOwner.displayName = currentUser.name;
        }
        if (this.context === 'edit') {
            this.selectedOwner = this.course.owner;
        }
        if (this.selectedOwner) {
            this.form.model.ownerId = this.selectedOwner.id;
        }
    }

    showAllSites () {
        return this.SiteService.hasAccessToAllSites(this.sites)
        || this.course.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
    }

    initMultiFilter () {
        this.allSitesOption = {
            value: null,
            label: this.$translate.instant('general.All sites')
        };

        const siteOptions = this.getSiteOptions();
        // NOTE: selectedOptions objects must be same as site options objects for multiselect to work
        const selectedSiteOptions = this.getSelectedSiteOptions(siteOptions);

        const fieldOptions = this.fields.map((field) => {
            return {
                value: field.id,
                label: field.activeI18nValue
            };
        });
        const selectedFieldOptions = this.getSelectedFieldOptions(fieldOptions);

        this.multiFilter = {
            sites: {
                models: selectedSiteOptions,
                options: siteOptions,
                settings: {
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 5,
                    smartButtonTextConverter: (itemText) => itemText
                },
                events: {
                    onItemDeselect: this.getSiteItemCallback(),
                    onItemSelect: this.getSiteItemCallback()
                },
                translations: {
                    buttonDefaultText: this.$translate.instant('filter.Select')
                }
            },
            fields: {
                options: fieldOptions,
                models: selectedFieldOptions,
                settings: {
                    enableSearch: true,
                    checkBoxes: true,
                    showCheckAll: false,
                    showUncheckAll: false,
                    smartButtonMaxItems: 10,
                    smartButtonTextConverter: (itemText) => itemText
                },
                translations: {
                    buttonDefaultText: this.$translate.instant('filter.Select')
                }
            }
        };
    }

    /**
     * Selected options have to be composed of siteOptions objects
     * they have to be references of each-other for multiselect to work
     * @param siteOptions
     * @returns {[]}
     */
    getSelectedSiteOptions (siteOptions) {
        let selectedOptions = [];
        if (this.course.sites && this.course.sites.length) {
            const selectedSiteIds = this.course.sites.map(site => site.id);
            selectedOptions = siteOptions.filter(option => this.lodash.includes(selectedSiteIds, option.value));
        }
        else if (this.course.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            selectedOptions.push(this.allSitesOption);
        }
        else {
            selectedOptions.push(...siteOptions);
        }
        return selectedOptions;
    }

    getSiteOptions () {
        const siteOptions = [];
        const cb = site => {
            return {
                value: site.id,
                label: site.name
            };
        };

        // 1. map all sites option if its selected or if user can manage site access
        if (this.showAllSites()) {
            siteOptions.push(this.allSitesOption);
        }
        // 2. map sites that user has access to via privileges
        this.lodash.forEach(this.sites, site => {
            siteOptions.push(cb(site));
        });

        // 3. map already attached course sites
        if (this.course.sites && this.course.sites.length) {
            this.lodash.forEach(this.course.sites, site => {
                siteOptions.push(cb(site));
            });
        }

        // 4. remove duplicates that might've come from sites and course.sites
        return this.lodash.uniqBy(siteOptions, option => option.value);
    }

    getSelectedFieldOptions (fieldOptions) {
        let selectedOptions = [];
        if (this.course.fields && this.course.fields.length) {
            const selectedFieldIds = this.course.fields.map(field => field.id);
            selectedOptions = fieldOptions.filter(option => this.lodash.includes(selectedFieldIds, option.value));
        }
        return selectedOptions;
    }

    /**
     * This callback makes sure that all sites option is always selected alone
     * - if all sites is selected uncheck every other option
     * - if any actual site option is selected unchecks all sites option
     * @returns {Function}
     */
    getSiteItemCallback () {
        return item => {
            const { multiFilter } = this;
            // if all sites option, set only it, otherwise deselect all sites if checkbox is selected
            if (item.value === null) {
                multiFilter.sites.models = [this.allSitesOption];
                this.form.model.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
            else {
                multiFilter.sites.models = multiFilter.sites.models.filter(model => model.value !== null);
                this.form.model.siteAccess = this.COURSE_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            }
        };
    }

    initCourse () {
        if (this.form.model.expirationMonths === null) {
            this.expiration = this.COURSE_EXPIRATION_ENUM.KEYS.NEVER;
        }
        else {
            if (this.lodash.findIndex(this.expirationOptions, { value: this.form.model.expirationMonths }) === -1) {
                const months = this.form.model.expirationMonths;
                if (months < 1200) {
                    if (months > 12) {
                        this.customExpiration.years = Math.floor(months / 12);
                    }
                    this.customExpiration.months = months % 12;
                }
                else {
                    this.customExpiration.years = 99;
                    this.customExpiration.months = 12;
                }
                this.expiration = this.COURSE_EXPIRATION_ENUM.KEYS.OTHER;
            }
        }

        const courseFieldIds = this.course.fields.map(field => field.id);
        this.chosenFields = this.lodash.filter(this.fields, field => this.lodash.includes(courseFieldIds, field.id));
    }

    clone (courseI18n) {
        return this.ModalService.open({
            template: `
                <modals-courses-cloned
                    uib-modal-instance="vm.$uibModalInstance"
                    course="vm.course"
                    class="wrapper"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.course = courseI18n;
            }
        });
    }

    changeCertificateTemplate () {
        if (
            !this.form.model.id ||
            !this.form.model.userCertificates.length ||
            this.form.model.companyCertificateId === this.oldCompanyCertificateId) {
            return;
        }
        const message = this.$translate.instant(
            'course.Changing the certificate template only affects certificates that have not been issued yet. Already generated certificates will not change. Are you sure you wish to continue?'
        );
        this.ModalService.confirm(message, 'medium').catch(() => {
            this.form.model.companyCertificateId = this.oldCompanyCertificateId;
        });
    }

    beforeSave () {
        this.form.invalid = false;
        this.form.model.expirationMonths = this.CourseService.getExpirationForModel(this.expiration, this.customExpiration);
        this.form.model.fields = this.chosenFields.map((val) => val.id);
        // if default language is not set(add scenario), set if for correct validation errors
        if (!this.lodash.has(this.form.model.courseI18ns, this.defaultLanguage)) {
            // we have to add empty name because this form is sent via upload which removes empty obj ({})
            this.lodash.set(this.form.model, `courseI18ns.${this.defaultLanguage}.name`, '');
        }
        if (this.form.model.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            this.form.model.courseSiteIds = [];
        }
        else {
            this.form.model.courseSiteIds = this.multiFilter.sites.models.map(siteOption => siteOption.value);
        }
        this.form.model.fields = this.multiFilter.fields.models.map(fieldOption => fieldOption.value);
        if (!this.form.model.fieldName) {
            this.form.model.addField = false;
        }
    }

    setFile (file) {
        this.form.model.file = file;
    }

    save (archive = false) {
        if (archive === false && this.form.model.isArchived) {
            return;
        }

        this.beforeSave();

        if (this.siteAccessHasChanged()) {
            const message = this.$translate.instant(
                'course.On changing the course access restriction you are changing who can access the course. Are you sure you wish to change course access restriction?'
            );
            this.ModalService.confirm(message, 'medium').then(() => this.manageUpload(archive));
        }
        else {
            this.manageUpload(archive);
        }
    }

    archive (state) {
        const confirmMessages = [];
        const message = !this.form.model.isArchived
            ? this.$translate.instant(
                'course.On archiving the course, all ongoing enrollments will be cancelled and course can longer be planned nor enrolled in. Are you sure you wish to archive the course?'
            )
            : this.$translate.instant(
                'course.Are you sure you wish to reactivate the course?'
            );
        confirmMessages.push(message);

        this.ModalService.confirm(confirmMessages, 'medium')
        .then(() => {
            this.form.model.isArchived = state;
            this.save(true);
            this.form.model.isArchived
                ? this.toastr.success(this.$translate.instant('course.Course successfully archived'))
                : this.toastr.success(this.$translate.instant('course.Course successfully reactivated'));
        });
    }

    siteAccessHasChanged () {
        if (!this.course.id) {
            return false;
        }

        if ((this.form.model.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES || this.course.siteAccess === this.COURSE_SITE_ACCESS_ENUM.KEYS.ALL_SITES)
            && this.form.model.siteAccess === this.course.siteAccess) {
            return false;
        }

        if (this.course.sites && this.course.sites.length) {
            const siteIds = this.course.sites.map(site => site.id);
            return siteIds.sort().toString() !== this.form.model.courseSiteIds.sort().toString();
        }

        return true;
    }

    manageUpload (archive) {
        let uploadUrl = `${SEED_CORE.ENV.API_URL}course/course`;
        let method = 'POST';

        this.loader = true;

        if (this.course.id) {
            delete this.form.model.$promise;
            delete this.form.model.$resolved;
            uploadUrl += `/${this.course.id}`;
            method = 'PUT';
        }

        this.Upload
            .upload({
                url: uploadUrl,
                data: this.lodash.assign({}, { file: this.form.file }, this.form.model),
                method
            })
            .then((response) => {
                if (archive === true) {
                    this.$rootScope.$broadcast('archiveChange', { isArchived: this.form.model.isArchived });
                }
                else {
                    if (this.context === 'add') {
                        this.$state.go('authorized.courses.courses.add.target', { id: response.data.id });
                    }
                    else {
                        this.toastr.success(this.$translate.instant('general.Changes saved'));
                    }
                }
            }).catch((response) => {
                this.form.invalid = true;
                this.form.saved = false;
                this.form.errors = this.ResponseService.parseErrors(response);
            })
            .finally(() => {
                this.loader = false;
            });
    }

    deleteImage () {
        const message = this.$translate.instant('course.Are you sure you want to delete the image?');
        this.ModalService.confirm(message, 'small').then(() => {
            this.CourseResource.deleteImage({ courseId: this.course.id }).$promise.then(() => {
                this.course.imageFilename = null;
            });
        });
    }

    getExpirationYearsLabel () {
        const years = this.customExpiration.years ? this.customExpiration.years : 1;
        return this.$translate.instant('course.{n, plural, one {year} other {years}}', { n: years });
    }

    getExpirationMonthsLabel () {
        const months = this.customExpiration.months ? this.customExpiration.months : 1;
        return this.$translate.instant('course.{n, plural, one {month} other {months}}', { n: months });
    }

    toggleCertType () {
        if (!this.certTypeOnLoad) {
            this.form.model.certificateNumberingType = this.form.model.isCertifiedCourse ? this.COURSE_CERTIFICATION_NUMBERING_TYPE_ENUM.KEYS.COMPANY_BASED : null;
        }
    }

    addField () {
        this.form.model.addField = true;
    }

    cancelAddField () {
        this.form.model.addField = false;
        this.form.model.fieldName = null;
    }

    handleExpirationValues () {
        if (this.customExpiration.years === undefined || this.customExpiration.years > 99) {
            this.customExpiration.years = 99;
        }

        if (this.customExpiration.months === undefined || this.customExpiration.months > 12) {
            this.customExpiration.months = 12;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/general/index.js